<template>
  <div><van-empty image="error" description="授权失败， 请重新进入" style="padding-top: calc((100vh - 260px) / 2);" /></div>
</template>

<script>
export default {
  name: 'LoginErrorView'
}
</script>

<style>

</style>
